// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__dF2va","copyright":"Footer_copyright__CDx8F"};